import { useState, useRef } from 'react';
import styles from './UserBar.module.css';
import { FiSettings } from "react-icons/fi";
import UserSettingsModal from '../Modals/UserSettingsModal/UserSettingsModal';
import Modal from '../Modals/Modal/Modal.jsx';
import { selectIsChatOpen } from '../../redux/chat/selectors.js';
import { useSelector } from 'react-redux';
import Tooltip from '../sharedComponents/Tooltip/Tooltip.jsx';
import useTooltip from '../../utils/useTooltip.jsx';

export default function UserBar() {
  const [isSettingsModalOpen, setSettingsModalOpen] = useState(false);
  const buttonRef = useRef(null);
  const chatIsOpen = useSelector(selectIsChatOpen);

    const {
      tooltipPosition,
      isTooltipVisible,
      handleMouseEnter,
      handleMouseMove,
      handleMouseLeave,
      handleClick,
    } = useTooltip();


  const openSettingsModal = () => {
    setSettingsModalOpen(true);
  };

  const closeSettingsModal = () => {
    setSettingsModalOpen(false);
  };

  const userBarClass = chatIsOpen ? `${styles.userBarContainer} ${styles.chatOpen}` : styles.userBarContainer;

  return (
    <div className={userBarClass}>
      <button
        className={styles.btn}
      
        ref={buttonRef}
        onClick={() => {
          openSettingsModal(), handleClick();
        }}
        onMouseEnter={handleMouseEnter}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
      >
        <FiSettings className={styles.iconSettings} />
        {isTooltipVisible && (
          <Tooltip
            isVisible={isTooltipVisible}
            position={tooltipPosition}
            text="Налаштування профілю"
          />
        )}
      </button>

      {isSettingsModalOpen && (
        <Modal isOpen={isSettingsModalOpen} onClose={closeSettingsModal}>
          <UserSettingsModal onClose={closeSettingsModal} />
        </Modal>
      )}
    </div>
  );
}
